// extracted by mini-css-extract-plugin
module.exports =  {"container":"_7506d987b5--container--vZhp6","link-area":"_7506d987b5--link-area--jbRPA","logo":"_7506d987b5--logo--qGlwa","content":"_7506d987b5--content--JOD3X"};